import { isArray as j, isEqual as ii } from "../util/code-utils.js";
import ti from "../models/push-token.js";
import { logger as r, EncodingUtils as ei } from "../../shared-lib/index.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
import yt from "./utils/push-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";
export default class ea {
  constructor(i, t, e, s, r, n, o, u, a, h, c) {
    (this.sn = i),
      (this.rn = t),
      (this.on = e),
      (this.un = r),
      (this.an = n),
      (this.hn = o),
      (this.yt = u),
      (this.cn = a),
      (this.fn = h),
      (this.u = c),
      (this.sn = i),
      (this.rn = t),
      (this.on = e),
      (this.ln = s + "/safari/" + t),
      (this.un = r || "/service-worker.js"),
      (this.hn = o),
      (this.yt = u),
      (this.cn = a || !1),
      (this.fn = h || !1),
      (this.u = c),
      (this.dn = yt.pn()),
      (this.bn = yt.yn());
  }
  mn() {
    return this.fn;
  }
  gn(i, t, e, s, n) {
    i.unsubscribe()
      .then((i) => {
        i
          ? this.vn(t, e, s, n)
          : (r.error("Failed to unsubscribe device from push."),
            "function" == typeof n && n(!1));
      })
      .catch((i) => {
        r.error("Push unsubscription error: " + i),
          "function" == typeof n && n(!1);
      });
  }
  wn(i, t, e) {
    var s;
    const n = ((i) => {
      if ("string" == typeof i) return i;
      if (0 !== i.endpoint.indexOf("https://android.googleapis.com/gcm/send"))
        return i.endpoint;
      let t = i.endpoint;
      const e = i;
      return (
        e.kn &&
          -1 === i.endpoint.indexOf(e.kn) &&
          (t = i.endpoint + "/" + e.kn),
        t
      );
    })(i);
    let o = null,
      u = null;
    const a = i;
    if (null != a.getKey)
      try {
        const i = Array.from(new Uint8Array(a.getKey("p256dh"))),
          t = Array.from(new Uint8Array(a.getKey("auth")));
        (o = btoa(String.fromCharCode.apply(null, i))),
          (u = btoa(String.fromCharCode.apply(null, t)));
      } catch (i) {
        r.error(si(i));
      }
    const h = ((i) => {
      let t;
      return i.options &&
        (t = i.options.applicationServerKey) &&
        t.byteLength &&
        t.byteLength > 0
        ? btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(t))))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
        : null;
    })(a);
    null === (s = this.sn) || void 0 === s || s.Pn(n, t, o, u, h),
      n && "function" == typeof e && e(n, o, u);
  }
  Dn() {
    var i;
    null === (i = this.sn) || void 0 === i || i.Sn(!0);
  }
  An(i, t) {
    var e;
    null === (e = this.sn) || void 0 === e || e.Sn(!1),
      r.info(i),
      "function" == typeof t && t(!1);
  }
  jn(i, t, e, s) {
    var n;
    if ("default" === t.permission)
      try {
        window.safari.pushNotification.requestPermission(
          this.ln,
          i,
          {
            api_key: this.rn,
            device_id:
              (null === (n = this.on) || void 0 === n ? void 0 : n.ce().id) ||
              "",
          },
          (t) => {
            "granted" === t.permission &&
              this.sn &&
              this.sn.setPushNotificationSubscriptionType(
                User.NotificationSubscriptionTypes.OPTED_IN,
              ),
              this.jn(i, t, e, s);
          },
        );
      } catch (i) {
        this.An("Could not request permission for push: " + i, s);
      }
    else
      "denied" === t.permission
        ? this.An(
            "The user has blocked notifications from this site, or Safari push is not configured in the Braze dashboard.",
            s,
          )
        : "granted" === t.permission &&
          (r.info("Device successfully subscribed to push."),
          this.wn(t.deviceToken, new Date(), e));
  }
  requestPermission(i, t, e) {
    const s = (s) => {
      switch (s) {
        case "granted":
          return void ("function" == typeof i && i());
        case "default":
          return void ("function" == typeof t && t());
        case "denied":
          return void ("function" == typeof e && e());
        default:
          r.error("Received unexpected permission result " + s);
      }
    };
    let n = !1;
    if ("default" !== window.Notification.permission)
      s(Notification.permission);
    else {
      const i = window.Notification.requestPermission((i) => {
        n && s(i);
      });
      i
        ? i.then((i) => {
            s(i);
          })
        : (n = !0);
    }
  }
  vn(i, t, e, s) {
    const n = { userVisibleOnly: !0 };
    null != t && (n.applicationServerKey = t),
      i.pushManager
        .subscribe(n)
        .then((i) => {
          r.info("Device successfully subscribed to push."),
            this.wn(i, new Date(), e);
        })
        .catch((i) => {
          yt.isPushBlocked()
            ? (r.info("Permission for push notifications was denied."),
              "function" == typeof s && s(!1))
            : (r.error("Push subscription failed: " + i),
              "function" == typeof s && s(!0));
        });
  }
  xn() {
    if (this.cn) return navigator.serviceWorker.getRegistration(this.un);
    const i = this.an ? { scope: this.an } : void 0;
    return navigator.serviceWorker.register(this.un, i).then(() =>
      navigator.serviceWorker.ready.then(
        (i) => (
          i &&
            "function" == typeof i.update &&
            i.update().catch((i) => {
              r.info("ServiceWorker update failed: " + i);
            }),
          i
        ),
      ),
    );
  }
  Nn(i) {
    this.cn ||
      (i.unregister(), r.info("Service worker successfully unregistered."));
  }
  subscribe(i, t) {
    if (!yt.isPushSupported())
      return r.info(ea.Un), void ("function" == typeof t && t(!1));
    if (this.dn) {
      if (!this.cn && null != window.location) {
        let i = this.un;
        -1 === i.indexOf(window.location.host) &&
          (i = window.location.host + i),
          -1 === i.indexOf(window.location.protocol) &&
            (i = window.location.protocol + "//" + i);
      }
      if (yt.isPushBlocked())
        return void this.An(
          "Notifications from this site are blocked. This may be a temporary embargo or a permanent denial.",
          t,
        );
      if (this.yt && !this.yt.Wn() && 0 === this.yt.ii())
        return (
          r.info(
            "Waiting for VAPID key from server config before subscribing to push.",
          ),
          void this.yt._n(() => {
            this.subscribe(i, t);
          })
        );
      const e = () => {
          r.info("Permission for push notifications was denied."),
            "function" == typeof t && t(!1);
        },
        s = () => {
          let i = "Permission for push notifications was ignored.";
          yt.isPushBlocked() &&
            (i +=
              " The browser has automatically blocked further permission requests for a period (probably 1 week)."),
            r.info(i),
            "function" == typeof t && t(!0);
        },
        n = yt.isPushPermissionGranted(),
        u = () => {
          !n &&
            this.sn &&
            this.sn.setPushNotificationSubscriptionType(
              User.NotificationSubscriptionTypes.OPTED_IN,
            ),
            this.xn()
              .then((e) => {
                if (null == e)
                  return (
                    r.error(
                      "No service worker registration. Set the `manageServiceWorkerExternally` initialization option to false or ensure that your service worker is registered before calling registerPush.",
                    ),
                    void ("function" == typeof t && t(!0))
                  );
                e.pushManager
                  .getSubscription()
                  .then((s) => {
                    var n;
                    let u = null;
                    if (
                      (null !=
                        (null === (n = this.yt) || void 0 === n
                          ? void 0
                          : n.Wn()) && (u = ei.Tn(this.yt.Wn())),
                      s)
                    ) {
                      let n,
                        a = null,
                        h = null;
                      if ((this.u && (n = this.u.j(o.C.In)), n && !j(n))) {
                        let i;
                        try {
                          i = ti.qn(n).Vn;
                        } catch (t) {
                          i = null;
                        }
                        null == i ||
                          isNaN(i.getTime()) ||
                          0 === i.getTime() ||
                          ((a = i),
                          (h = new Date(a)),
                          h.setMonth(a.getMonth() + 6));
                      }
                      null != u &&
                      s.options &&
                      s.options.applicationServerKey &&
                      s.options.applicationServerKey.byteLength &&
                      s.options.applicationServerKey.byteLength > 0 &&
                      !ii(u, new Uint8Array(s.options.applicationServerKey))
                        ? (s.options.applicationServerKey.byteLength > 12
                            ? r.info(
                                "Device was already subscribed to push using a different VAPID provider, creating new subscription.",
                              )
                            : r.info(
                                "Attempting to upgrade a gcm_sender_id-based push registration to VAPID - depending on the browser this may or may not result in the same gcm_sender_id-based subscription.",
                              ),
                          this.gn(s, e, u, i, t))
                        : s.expirationTime &&
                          new Date(s.expirationTime).valueOf() <=
                            new Date().valueOf()
                        ? (r.info(
                            "Push subscription is expired, creating new subscription.",
                          ),
                          this.gn(s, e, u, i, t))
                        : n && j(n)
                        ? this.gn(s, e, u, i, t)
                        : null == h
                        ? (r.info(
                            "No push subscription creation date found, creating new subscription.",
                          ),
                          this.gn(s, e, u, i, t))
                        : h.valueOf() <= new Date().valueOf()
                        ? (r.info(
                            "Push subscription older than 6 months, creating new subscription.",
                          ),
                          this.gn(s, e, u, i, t))
                        : (r.info(
                            "Device already subscribed to push, sending existing subscription to backend.",
                          ),
                          this.wn(s, a, i));
                    } else this.vn(e, u, i, t);
                  })
                  .catch((i) => {
                    r.error("Error checking current push subscriptions: " + i);
                  });
              })
              .catch((i) => {
                r.error("ServiceWorker registration failed: " + i);
              });
        };
      this.requestPermission(u, s, e);
    } else if (this.bn) {
      if (null == this.hn || "" === this.hn)
        return (
          r.error(
            "You must supply the safariWebsitePushId initialization option in order to use registerPush on Safari",
          ),
          void ("function" == typeof t && t(!0))
        );
      const e = window.safari.pushNotification.permission(this.hn);
      this.jn(this.hn, e, i, t);
    }
  }
  unsubscribe(i, t) {
    if (!yt.isPushSupported())
      return r.info(ea.Un), void ("function" == typeof t && t());
    this.dn
      ? navigator.serviceWorker.getRegistration(this.un).then((e) => {
          e
            ? e.pushManager
                .getSubscription()
                .then((s) => {
                  s
                    ? (this.Dn(),
                      s
                        .unsubscribe()
                        .then((s) => {
                          s
                            ? (r.info(
                                "Device successfully unsubscribed from push.",
                              ),
                              "function" == typeof i && i())
                            : (r.error(
                                "Failed to unsubscribe device from push.",
                              ),
                              "function" == typeof t && t()),
                            this.Nn(e);
                        })
                        .catch((i) => {
                          r.error("Push unsubscription error: " + i),
                            "function" == typeof t && t();
                        }))
                    : (r.info("Device already unsubscribed from push."),
                      "function" == typeof i && i());
                })
                .catch((i) => {
                  r.error("Error unsubscribing from push: " + i),
                    "function" == typeof t && t();
                })
            : (r.info("Device already unsubscribed from push."),
              "function" == typeof i && i());
        })
      : this.bn &&
        (this.Dn(),
        r.info("Device unsubscribed from push."),
        "function" == typeof i && i());
  }
}
ea.Un = "Push notifications are not supported in this browser.";
